<template>
  <router-view />
  <Toast />
</template>

<script setup lang="ts">
  // local components
  import Toast from '@/components/ui/Toast.vue';
</script>

<style lang="scss" scoped>
</style>